import React from "react";

const PIP_LAYOUT = {
  1: [4],
  2: [0, 8],
  3: [0, 4, 8],
  4: [0, 2, 6, 8],
  5: [0, 2, 4, 6, 8],
  6: [0, 2, 3, 5, 6, 8],
};

const BondDieFace = ({ value, size = "lg" }) => {
  const n = Math.floor(Number(value));
  const layout = PIP_LAYOUT[n];

  if (!layout) {
    return <span className={`bdice-die-unknown bdice-die-unknown-${size}`}>?</span>;
  }

  const on = new Set(layout);

  return (
    <span className={`bdice-pips bdice-pips-${size}`} role="img" aria-label={`Dice face ${n}`}>
      {Array.from({ length: 9 }).map((_, i) => (
        <span key={i} className={`bdice-pip${on.has(i) ? " on" : ""}`} aria-hidden />
      ))}
    </span>
  );
};

export default BondDieFace;
